import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

/**
 * options: Required<DurationFormatterConfig>
 */
export class DurationFormatterImpl {
  _options = null;
  constructor(options) {
    this._options = options;
  }

  // Method takes an integer value, representing the number of milliseconds
  format(value) {
    dayjs.extend(duration);
    return dayjs.duration(value).format(this._options.template);
  }
}

export const createDayJsDurationFormatterFactory = ({ defaultTemplate }) => ({
  template = defaultTemplate,
} = {}) => {
  return new DurationFormatterImpl({ template });
};
